/**
* @description: 特殊任务列表
*/
<template>
    <div class="finance_box" ref="myElementRef">
        <div ref="searchBox">
            <hc-search :data="searchData" @serch="getSearch">
                <template #btns>
                    <el-button type="primary" icon="Plus"
                @click="$refs['editImprove'].open()">{{ t('common.add') }}</el-button>
                </template>
            </hc-search>
        </div>
        <!-- 表格 -->
        <div class="table_box">
            <hc-table :tableData="state.tableData" :column="state.tableHeader" :offsetHeight="state.offsetHeight"
            :maxPage="maxPage"
                @pageChange="pageChange" @limitChange="limitChange">
                <template #created_at="{ row }">
                    {{ formatDisplayDateTime(row.created_at) }}<el-tag v-if="isOvertime(row.created_at)" type="danger" size="small" style="margin-left: 10px;">{{ t('improveList.ended') }}</el-tag>
                </template>
                <template #status="{ row }">
                    <!-- <el-tag :type="statusTypeMap[row.status]">{{ listToMap(statusOptions, {})[row.status] }}</el-tag> -->
                     {{ listToMap(statusOptions, {})[row.status] }}
                </template>
                <template #operation="scope">
                    <div class="btn_box_det">
                        <el-button class="opBtn" size="small" type="primary" link
                            @click="$refs['editImprove'].open(scope.row)">{{ t('common.edit') }}</el-button>
                        <!-- <el-button class="opBtn" size="small" type="primary" link
                            @click="$refs['setMember'].open(scope.row)">安排人员</el-button> -->
                    </div>
                </template>
            </hc-table>
        </div>
        <!-- 新增 -->
        <EditImprove ref="editImprove" :title="state.title" @refresh="getSearch(searchData)" />

        <!-- 安排人员 -->
        <SetMember ref="setMember" :title="t('taskSpecial.assignMember')" @refresh="getSearch(searchData)" />
    </div>
</template>

<script setup>
import hcSearch from "@/components/hc-search/index.vue";
import hcTable from "@/components/hc-table/index.vue";
import { onMounted, reactive, ref, nextTick, onUnmounted, onActivated, toRaw } from "vue";
import EditImprove from "./components/editImprove.vue";
import SetMember from "./components/setMember.vue";

import { pageListApi as userListApi } from "@/api/system/personnel";
import { pageListApi } from "@/api/improve/improve.js";
import { listToMap } from "@/utils/utils";
import { formatDisplayDateTime } from "@/utils/dateTime.js";
import { usePageI18n } from "@/composables/usePageI18n.js";
import { applyImproveListLabels } from "@/utils/improveListI18n.js";
const myElementRef = ref();
const searchBox = ref();
const editImprove = ref();
const isOvertime = (time) => {
    const currentTime = new Date(); // 当前时间
    const targetDate = new Date(time); // 传入的时间

    // 比较时间戳（毫秒数）
    return targetDate.getTime() < currentTime.getTime();
}

let page = ref(1);
let limit = ref(20);
let maxPage = ref(0);
const statusOptions = reactive([
    { label: "已发布", value: 1 },
    { label: "未发布", value: 0 }
])

const statusTypeMap = reactive({
    1: 'success',
    0: 'danger'
})

const searchData = reactive([
    {
        label: "标题关键词",
        type: "input",
        value: "",
        field: 'keywords'
    },
]);

const getUserList = () => {
    const params = JSON.stringify({
        "page": 1,
        "limit": 9999,
        "keywords": "",
        "role_id": 0
    })
    
    userListApi(params).then(res => {
        getSearch(searchData)
    })
}

const state = reactive({
    user: {},
    title: "",
    column: [
        {
            prop: "id",
            show: false,
            label: "任务ID",
        },
        {
            // prop: "id",
            show: true,
            type: "index",
            label: "序号",
            width: 80,
        },
        {
            prop: "title",
            show: true,
            label: "标题",
        },
        // {
        //     prop: "real_name",
        //     show: true,
        //     label: "发布人",
        // },
        {
            prop: "description",
            show: true,
            label: "描述",
        },
        {
            prop: "score",
            show: true,
            label: "分值",
            width: 80,
        },
        {
            prop: "status",
            show: true,
            label: "状态",
        },
        {
            prop: "updated_at",
            show: true,
            label: "开始时间",
        },
        {
            prop: "created_at",
            show: true,
            label: "截至时间",
        },
        {
            prop: "operation",
            show: true,
            label: "操作",
            width: 240
        },
    ],
    offsetHeight: 0,
    tableHeader: [],
    tableData: [
        // {
        // "score": 10,
        // "start_time": "2025-05-09 22:50:05",
        // "updated_at": "2025-05-08 22:50:17",
        // "end_time": "2025-05-31 22:50:11",
        // "description": "特殊任务特殊任务特殊任务特殊任务",
        // "created_at": "2025-05-08 22:50:17",
        // "id": 1,
        // "title": "特殊任务",
        // "status": 1
        // }
    ]
});

const init = () => {
    const { user } = JSON.parse(localStorage.getItem("user"));
    state.user = user.users
    getUserList()
};

// 动态改变表头
const change = (item) => {
    tableHeaderFn();
};

const offHeighths = () => {
    if (myElementRef.value) {
        state.offsetHeight =
            myElementRef.value?.offsetHeight - 90 - searchBox.value?.offsetHeight;
    }
};

const pageChange = (currentPage) => {

    page.value = currentPage;
    getSearch(searchData)
}

const limitChange = (currentLimit) => {

    limit.value = currentLimit;
    getSearch(searchData)
}

onMounted(() => {
    try {
        nextTick(() => {
            offHeighths();
        });
        window.onresize = () => {
            nextTick(() => {
                offHeighths();
            });
        };
        applyLabels();
        tableHeaderFn();
        init();
    } catch { }
});

onUnmounted(() => {
    window.onresize = null;
});

// 查询过来的数据
const getSearch = (params = []) => {
    const form = listToMap(toRaw(params), { value: 'value', key: 'field' })
    const requestParams = {
        page: page.value,
        limit: limit.value,
        ...form
    }
    state.loading = true
		pageListApi(JSON.stringify(requestParams)).then(res => {
      maxPage.value = res?.maxPage ?? 0;
      state.tableData = res?.data?.map(item => {
        return {
          ...item,
        //   status: listToMap(statusOptions, {})[item.status],
        }
      }) ?? []
    }).finally(() => {
		state.loading = false
	})
};

const applyLabels = () => {
    applyImproveListLabels({ searchData, columns: state.column, statusOptions });
};
const { t } = usePageI18n(applyLabels);

// 表头筛选
const tableHeaderFn = () => {
    state.tableHeader = state.column.filter((v) => {
        if (v.show) {
            return v.show == true;
        } else {
            v.show = false;
        }
    });
};
</script>

<style lang="less" scoped>
.finance_box {
    flex: 1;
    overflow: auto;
    background-color: #fff;
    border-radius: 6px;
    padding: 10px;
    margin-right: 10px;
}

.btn_box {
    height: 40px;
    display: flex;
}

.table_box {
    width: 100%;
}

/deep/.el-button-group .el-button--primary:first-child {
    background-color: #1e6aed;
    border: none;
}

.serBtn {
    margin-left: 10px;
    background-color: #f0f0f0;
    color: #000;
    border: none;
}

.serBtn:hover {
    background-color: #f0f0f0;
    color: #000;
}

.opBtn {
    // margin: 0 !important;
    margin: 0 10px 0 0;
}

.opBtn:hover {
    color: #e6a755;
}
</style>
